import type { RouteRecordRaw, RouteLocationNormalized } from 'vue-router'

// Componentes de API
import ApiCatalogOld from '@/views/api/ApiCatalogOld.vue'
import ApiCatalog from '@/views/api/ApiCatalog.vue'
import ApiDetails from '@/views/api/ApiDetails.vue'
import ApiDetailsOld from '@/views/api/ApiDetailsOld.vue'

// Lazy loading
const SwaggerEditor = () => import('@/views/SwaggerEditor.vue')
const ApiReferenceComponent = () => import('@/views/api/ApiReferenceComponent.vue')

const apiRoutes: RouteRecordRaw[] = [
  {
    path: '/apis-old',
    name: 'ApiCatalogOld',
    component: ApiCatalogOld,
    meta: { 
      requiresAuth: true,
      title: 'Catálogo de APIs - Antigo',
      breadcrumbTitle: 'APIs - Antigo'
    }  
  },
  {
    path: '/apis-old/:id',
    name: 'ApiDetailsOld',
    component: ApiDetailsOld,
    meta: { 
      requiresAuth: true,
      title: 'Detalhes da API - Antigo',
      breadcrumbTitle: 'Detalhes da API - Antigo'
    }
  },  
  // rota '/apis' removida
  {
    path: '/swagger-editor',
    name: 'SwaggerEditor',
    component: SwaggerEditor,
    meta: { requiresAuth: true, requiredItem: 'tools.swagger' }
  }
]

export default apiRoutes